import { createContext, useContext, useState } from 'react';
import { Role } from '../types/roles';

// datatype of the context declared here
interface IRoleContext {
  targetedRole: Role | null;
  showDeleteModal: boolean;
  showEditModal: boolean;
  setTargetedRole: React.Dispatch<React.SetStateAction<Role | null>>;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the context here
const RoleContext = createContext<IRoleContext | null>(null);

const RoleProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [targetedRole, setTargetedRole] = useState<Role | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // rendering the context provider here
  return (
    <RoleContext.Provider
      value={{
        targetedRole,
        showDeleteModal,
        showEditModal,
        setTargetedRole,
        setShowDeleteModal,
        setShowEditModal,
      }}
    >
      {children}
    </RoleContext.Provider>
  );
};

export default RoleProvider;

// custom hook to access role context declared here
export const useRoleContext = () => {
  const context = useContext(RoleContext);

  if (!context) {
    throw new Error('useRoleContext must be within RoleProvider!');
  }

  return context;
};
